import Footer from './components/footer/Footer.vue';
import Drawer from './components/drawer/Drawer.vue';
import Header from './components/header/Header.vue';
import Cookies from './components/cookies/Cookies.vue';

export default {
  data() {
    return {};
  },
  components: {
    Drawer,
    Header,
    Footer,
    Cookies,
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    layout() {
      return this.$store.state.settings.layout;
    },
    bgUrl() {
      return this.$store.state.settings.bgUrl;
    },
    /** Верхнее меню */
    topMenuItems() {
      if (this.isAuthenticated && !this.isBlocked) {
        const menu = [
          {
            title: 'Личный кабинет',
            path: '/dashboard',
            icon: 'home',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Продажи',
            path: '/sales',
            icon: 'ruble-sign',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Призы',
            path: '/prizes',
            icon: 'gift',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Заказы',
            path: '/orders',
            icon: 'file-alt',
            showIcon: true,
            showTitle: true,
          },
        ];
        return menu;
      }
      return [];
    },
    /** Левое мобильное меню в дровере */
    leftMenuItems() {
      return [
        {
          title: 'Главная страница',
          path: '/',
          icon: 'home',
        },
        {
          title: 'Помощь',
          path: '/feedback',
          icon: 'question-circle',
        },
        {
          title: 'Войти',
          path: '/login',
          icon: 'sign-in-alt',
        },
      ];
    },
  },
  methods: {

  },
  created() {
    this.$store.dispatch('GetSettings');
    this.$store.commit('SetLoading', false);
  },
};
